import type { NotificationProps } from '~/plugins/01.notification'

type NotificationController = {
   add: (props: NotificationProps) => void
}

export const useNotification = (): NotificationController => {
   const { $notification } = useNuxtApp()
   return $notification as NotificationController
}
